export default __webpack_public_path__ + "static/media/banner-home-mobile.0b8f944d.png";